import { Repository, EntityRepository } from 'typeorm';
import { GrnItemReturns } from '../grn-item-return-entity';


@EntityRepository(GrnItemReturns)
export class GrnItemReturnRepository extends Repository<GrnItemReturns>{

    
}
